import type { TerraUIMessage } from '@terra/shared-dto-chat-types';

export const DEFAULT_CHAT_HISTORY_PAGE_SIZE = 50;

export type PaginatedChatHistoryPage = {
  history: TerraUIMessage[];
  nextCursor: number | null;
  hasMore: boolean;
};

export type FetchChatHistoryPage = (args: {
  threadId: string;
  limit?: number;
  cursor?: number;
}) => Promise<PaginatedChatHistoryPage | null>;
